// Single source of truth for table page-size choices (field request: rows per
// page were inconsistent across pages — 11 different combinations existed).
// Exposed to all components as $rowsPerPageOptions via Vue.prototype (main.js).
export const ROWS_PER_PAGE_OPTIONS = [1, 5, 10, 20, 50, 100];
